export default "__VITE_ASSET__CanpMZuH__"